
export default {
  name: 'TheTile',

  props: {
    header: {
      type: String,
      required: false,
      default: '',
    },
    paragraph: {
      type: String,
      required: false,
      default: '',
    },
    image: {
      type: String,
      required: false,
      default: '',
    },
    order: {
      type: Number,
      required: true,
    },
    imageFirst: {
      type: Boolean,
      required: false,
      default: false,
    },
    fullHeightImage: {
      type: Boolean,
      required: false,
      default: false,
    },
    imageToBottom: {
      type: Boolean,
      required: false,
      default: false,
    },
    isAdditionalTabVisible: {
      type: Boolean,
      required: false,
      default: false,
    },
    additionalTabContent: {
      type: String,
      required: false,
      default: '',
    },
    category: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  methods: {
    setCategoryFromTile(category) {
      this.$emit('select-category', category);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Common/TheTile/component.js